import { FC } from "react";

const CMother: FC = () => {
    return (
        <>
            <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M6.68867 6.31133C7.31703 5.68297 8.33579 5.68297 8.96414 6.31133L12.3773 9.72453L15.7906 6.31133C16.4189 5.68297 17.4377 5.68297 18.066 6.31133C18.6944 6.93968 18.6944 7.95844 18.066 8.5868L14.6528 12L18.066 15.4132C18.6944 16.0416 18.6944 17.0603 18.066 17.6887C17.4377 18.317 16.4189 18.317 15.7906 17.6887L12.3773 14.2755L8.96414 17.6887C8.33579 18.317 7.31703 18.317 6.68867 17.6887C6.06032 17.0603 6.06032 16.0416 6.68867 15.4132L10.1019 12L6.68867 8.5868C6.06032 7.95844 6.06032 6.93968 6.68867 6.31133Z"
                  fill="#167E76"
                  stroke="#51C2B9"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
            </svg>
        </>
    )
}

export default CMother;